export default __webpack_public_path__ + "img/61f33f057692eb69273f9fa5059329e0.jpg";